import React, { Fragment } from "react";
import { Provider } from "react-redux";

import { getLocale } from "@utils/configuration/aem";
import {
    ErrorBoundary,
    ErrorBoundaryFallbackComponent,
} from "@utils/errorBoundary";

import { TStore } from "@redux/store.types";

const GraniteProvider = React.lazy(() =>
    import("@redux/modules/value/translations/translations.provider").then(
        module => ({ default: module.GraniteProvider }),
    ),
);

const LanguageProvider = React.lazy(() =>
    import("@context/language.context").then(module => ({
        default: module.LanguageContextProvider,
    })),
);

type Props = {
    data: DOMStringMap;
    innerHTML: string;
    store: TStore;
    componentReference?: any;
};

const Entry = ({ data, innerHTML, store, componentReference }: Props) => {
    if (!componentReference) {
        console.log("hubo:render - component not found", data?.cqDataPath);
        return <Fragment />;
    }

    return (
        <ErrorBoundary FallbackComponent={ErrorBoundaryFallbackComponent}>
            <React.Suspense>
                <Provider store={store}>
                    <LanguageProvider language={getLocale()}>
                        <GraniteProvider>
                            {React.createElement(componentReference, {
                                innerHTML,
                                ...data,
                            })}
                        </GraniteProvider>
                    </LanguageProvider>
                </Provider>
            </React.Suspense>
        </ErrorBoundary>
    );
};

export default Entry;
